import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { MyButton } from '@interstellar-component'
import { AlertTriangle } from '@untitled-ui/icons-react'

import { useApp } from '../../AppContext'

// Must match RegisterCompanyInfo/Context COMPANY_ID_STORAGE_KEY — the wizard
// resumes the draft whose id is in this localStorage key on mount.
const REGISTER_COMPANY_ID_KEY = 'register_company_id'

// Don't nag where the user is already dealing with the company: the wizard
// itself and the /company view (which shows the same draft state inline).
const HIDDEN_PREFIXES = ['/register-company-info', '/company']

/**
 * Global overlay reminder shown on other pages when a single-company user still
 * has an unfinished company enrollment. Reads the holding-scoped company summary
 * from /auth/session (company_context). Fixed-position so it doesn't disturb
 * page layout.
 */
export default function IncompleteCompanyBanner() {
  const { companyContext } = useApp()
  const location = useLocation()
  const navigate = useNavigate()

  const companies = companyContext?.companies ?? []
  const company = companyContext?.count === 1 ? companies[0] : null
  // "belum selesai ngisi form create company" — enrollment not completed yet.
  const incomplete = !!company && company.enrollment_status !== 'completed'

  const hidden = HIDDEN_PREFIXES.some(
    (p) => location.pathname === p || location.pathname.startsWith(`${p}/`)
  )

  if (!incomplete || hidden) return null

  const handleResume = () => {
    localStorage.setItem(REGISTER_COMPANY_ID_KEY, company.id)
    navigate('/register-company-info')
  }

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-5 z-50 flex justify-center px-4">
      <div className="pointer-events-auto flex w-full max-w-2xl items-center gap-3 rounded-xl border border-warning/300 bg-warning/50 px-4 py-3 shadow-lg">
        <AlertTriangle
          className="size-5 shrink-0 text-warning/600"
          stroke="currentColor"
          aria-hidden
        />
        <div className="min-w-0 flex-1">
          <p className="text-sm-semibold text-warning/800">
            Complete your company registration
          </p>
          <p className="truncate text-xs-regular text-warning/700">
            Registration for {company.name || 'your company'} is not finished yet — complete
            it to start using the service.
          </p>
        </div>
        <MyButton
          color="primary"
          variant="filled"
          size="sm"
          type="button"
          onClick={handleResume}
        >
          <span className="text-sm-semibold">Continue</span>
        </MyButton>
      </div>
    </div>
  )
}
